<template>
  <v-layout :title="$t('help_index.title')">
    <b-container fluid class="buttons">
      <b-row>
        <b-col
          v-for="(page, index) in pages"
          :key="index"
          cols="12"
          md=""
          class="page py-5"
        >
          <router-link :to="page.route">
            <div class="h-100 d-flex flex-column">
              <component
                v-bind:is="page.icon"
                class="mb-5 mx-auto"
              ></component>
              <div class="text-uppercase mt-auto">
                {{ page.text }}
              </div>
            </div>
          </router-link>
        </b-col>
      </b-row>
    </b-container>
  </v-layout>
</template>


<script>
import VLayout from "@/layouts/Default";

import SVGSignUp from "@/static/help/ic_signup.svg";
import SVGUser from "@/static/help/ic_user.svg";
import SVGCart from "@/static/help/ic_carrito.svg";
import SVGBox from "@/static/help/ic_caja.svg";
import SVGCard from "@/static/help/ic_tarjeta.svg";

export default {
  components: {
    VLayout,
  },
  data () {
    return {
      pages: [
        {
          icon: SVGSignUp,
          text: this.$t("help_index.sign_up"),
          route: { name: "sign-up-help" },
        },
        {
          icon: SVGUser,
          text: this.$t("help_index.my_account"),
          route: { name: "account-help" },
        },
        {
          icon: SVGCart,
          text: this.$t("help_index.my_purchases"),
          route: { name: "purchases-help" },
        },
        {
          icon: SVGBox,
          text: this.$t("help_index.delivery_refunds"),
          route: { name: "delivery-help" },
        },
        {
          icon: SVGCard,
          text: this.$t("help_index.payment_methods"),
          route: { name: "payment-help" },
        },
      ],
    };
  },
  fallbackI18n: {
    messages: {
      und: {
        help_index: {
          title: "How does it work?",
          breadcrumb: "How does it work?",
          sign_up: "Sign up",
          my_account: "My account",
          my_purchases: "My purchases",
          delivery_refunds: "Delivery and refunds",
          payment_methods: "Payment methods",
        },
      },
    },
  },
};
</script>


<style lang="scss" scoped>
.buttons {
  margin: 7rem 0 7rem 0;
}

.page:not(:last-child) {
  border-right: 1px solid $border-color;

  @include media-breakpoint-down(md) {
    border: none;
  }
}

.page a {
  color: $text-main-color;
  font-size: $font-size-medium * 1.1;
  text-decoration: none;

  & svg {
    fill: $corp-color2;
  }

  &:hover svg {
    fill: $corp-color2-light;
  }
}
</style>
